// Padopbouw voor de bucket blog-images, los van de upload zelf zodat hij testbaar is.
//   wizard         <userId>/wizard/<sessionId>/uploaded.webp                     (één vast bestand: de uitgelichte foto)
//   wizard-inline  <userId>/wizard/<sessionId>/inline/<tijd>-<random>-uploaded.webp (foto's in de tekst tijdens de wizard)
//   blog           <userId>/blogs/<blogId>/<tijd>-<random>-uploaded.webp          (foto's in de tekst van een bestaand blog)
//   social         <userId>/social/<postId>/<tijd>-<random>-uploaded.webp         (beelden van een social post; de map is de post die
//                  het bestand als eerste uploadde, een volgende post kan de reeks overnemen zonder opnieuw te uploaden)
export type StorageContext = 'wizard' | 'wizard-inline' | 'blog' | 'social';
export type StorageIds = { sessionId?: string; blogId?: string; postId?: string };

const uniqueName = () => `${Date.now()}-${Math.random().toString(36).slice(2, 8)}-uploaded.webp`;

export function storagePathFor(userId: string, context: StorageContext, ids: StorageIds): string {
  if (context === 'wizard' && ids.sessionId) return `${userId}/wizard/${ids.sessionId}/uploaded.webp`;
  if (context === 'wizard-inline' && ids.sessionId) return `${userId}/wizard/${ids.sessionId}/inline/${uniqueName()}`;
  if (context === 'blog' && ids.blogId) return `${userId}/blogs/${ids.blogId}/${uniqueName()}`;
  if (context === 'social' && ids.postId) return `${userId}/social/${ids.postId}/${uniqueName()}`;
  throw new Error('Invalid context or missing sessionId/blogId/postId');
}
